<template>
  <div class="position-relative">
    <div class="box-thead-add-by-amazon-sticky">
      <div class="box-empty flexbox justify-between">
        <div class="box-add-amz-product-checked-all">
          <button v-if="checkedItems.length" type="button" class="btn btn-warning add-amz-product-checked-all" @click="$emit('addProducts')">選択した商品を追加</button>
        </div>
        <pagination
            :totalPage="totalPage"
            :currentPage="currentPage"
            :paginationStorageKey="paginationStorageKey"
            @updateCurrentPage="updateCurrentPage"
          />
      </div>
      <div class="table-wrapper-add-by-amazon-sticky">
        <div class="table-wrapper hide-scrollbar" @scroll="handleScrollTheadSticky($event)">
          <table class="table table-bordered common-table">
            <thead class="thead-visibility" id="product-table-header">
              <tr class="align-middle">
                <th
                  v-for="(column, index) in columns"
                  :key="index"
                  :class="column.headerClass"
                  :id="`sticky-header-product-`+ index"
                  :style="{width: column.width, 'min-width' : column.minWidth, 'max-width' : column.maxWidth}"
                  @click="handleClickHeader(column)"
                  v-html="`${column.label}`"
                >
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
    <div class="table-wrapper" @scroll="handleScrollTheadSticky($event)">
      <table class="table table-bordered common-table">
        <thead class="thead-not-visibility">
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :key="index"
              :class="column.headerClass"
              :id="column.field"
              :style="{width: column.width, 'min-width' : column.minWidth, 'max-width' : column.maxWidth}"
              @click="handleClickHeader(column)"
              v-html="`${column.label}`"
            >
            </th>
          </tr>
        </thead>
        <tbody class="tbody-visibility">
          <tr v-if="!initial && countData === 0">
            <td :colspan="columns.length" align="center" class="bg-danger text-danger" style="background-color: #f2dede">
              <h5 class="font-bold">データが見つかりません。</h5>
            </td>
          </tr>
          <tr v-for="(item, index) in pageData" :key="index" @click="selectRowRequest(item)" v-else>
            <td
              v-for="(column, colIndex) in columns"
              :key="index + '-' + colIndex"
              :class="column.cellClass"
              :style="{width: column.width}"
            >
              <template v-if="column.customCell">
                <slot :name="column.name" :row-data="item" :handle-data="handleData" :data="defaultData" :original-data="originalData"></slot>
                <details v-if="column.detailAmountCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.amountDetails }}</p>
                </details>
                <details v-if="column.detailTransactionCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.transactionDetails }}</p>
                </details>
              </template>
              <template v-else>
                <span>
                  {{ item[column.name] }}
                </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <get-data
      :url="this.url"
      :extraUrl="this.extraUrl"
      :extraUrlMode="this.extraUrlMode"
      @onChangePage="onChangePage"
      @zIndex="$emit('zIndex', $event)"
      @originalData="getOriginalData"
      :keyword="keyword"
      :isShowPromotionProduct="isShowPromotionProduct"
      :needExtraData="needExtraData"
      :maxRows="maxRows"
      :loadingTableMode="loadingTableMode"
      :isHideNoItem="isHideNoItem"
      :currentPage="currentPage"
      @updateCurrentPage="updateCurrentPage"
      :method="method"
      ref="pagination"
    />
    <pagination
      v-if="pageData.length >= 50"
      class="flex mr-t-20"
      :totalPage="totalPage"
      :currentPage="currentPage"
      :paginationStorageKey="paginationStorageKey"
      @updateCurrentPage="updateCurrentPage"
    />
  </div>
</template>
<script>
import Pagination from '@/components/PaginationNextPage'
import GetData from '@/view/productsNew/GetData'
export default {
  components: {
    Pagination,
    GetData
  },
  data () {
    return {
      pageData: [],
      defaultData: [],
      originalData: [],
      countData: 0,
      initial: true,
      start: null,
      end: null,
      detail: null,
      mall: null,
      checkAll: false,
      filterAllDataCount: 0,
      totalPage: 1,
      currentPage: 1
    }
  },
  computed: {
    maxRows () {
      return this.$store.getters.getPaginationRow(this.paginationStorageKey)
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    isHideNoItem: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: ''
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    },
    malls: {
      type: Array,
      default: null
    },
    keyword: {
      type: String,
      default: ''
    },
    isShowPromotionProduct: {
      type: Boolean,
      default: false
    },
    checkedItems: {
      type: Array,
      default () {
        return []
      }
    },
    paginationStorageKey: {
      type: String,
      default: ''
    }
  },
  created () {
    this.totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
  },
  methods: {
    getOriginalData (data) {
      this.originalData = [...data]
    },
    /*
     * Handle on page change
     *
     * @param {Array} data All Data for table from API
     * @param {Object} extraData Extra data get from API
     *
     * @return void
     */
    onChangePage (data, extraData, filterAllDataCount) {
      this.filterAllDataCount = filterAllDataCount
      this.totalPage = Math.ceil(this.filterAllDataCount / this.maxRows)
      this.defaultData = this.pageData = [...data]
      this.countData = this.defaultData.length
      this.$emit('countData', this.countData)
      if (this.initial) {
        this.initial = false
      }
      if (this.needExtraData) {
        this.$emit('extraData', extraData)
      }
    },
    handleClickHeader (column) {
      if (column.name === 'deleteCheckBox') {
        this.checkAll = !this.checkAll
        this.$emit('checkBoxAll', this.checkAll)
      }
    },
    /*
     * Handle change data from parent component
     *
     * @param {Object} item Record to be changed
     * @param {String} type Type of changed
     * @param {Boolean} isCallApi Need to call API
     *
     * @return void
     */
    handleData (item, type) {
      this.$refs.pagination.handleData(item, type)
    },
    renderIconTag (classes) {
      return `<i class="${classes.join(' ')}"></i>`
    },
    /*
     * Handle onclick reload button
     *
     * @param {Boolean} showLoading Need show loading for table
     * @param {Boolean} keepKeyword Is remove current keyword or not
     *
     * @return void
     */
    reload () {
      this.$refs.pagination.reload()
    },
    handleFilter () {
      this.$refs.pagination.handleFilter()
    },
    selectRowRequest (event) {
      this.$emit('clickRow', event)
    },
    handleScrollTheadSticky (event) {
      $('#product-add-by-amazon .table-wrapper').scrollLeft(event.target.scrollLeft)
    },
    setWithHeaderTabAddByAmazon (headerClass) {
      let elm = document.getElementById(headerClass)
      if (elm) {
        let getBounding = elm.getBoundingClientRect()
        return getBounding.width + 'px'
      }
    },
    resetHeaderTabAddByAmazon () {
      let addByAmazonHeaderIds = [
        'deleteCheckBox',
        'productName',
        'numberOfStock',
        'action'
      ]
      addByAmazonHeaderIds.forEach((headerId, headerIndex) => {
        let widthHeader = this.setWithHeaderTabAddByAmazon(headerId + '-amazon')
        let selectorHeader = $('#sticky-header-addbyamazon-' + headerIndex)
        selectorHeader.css('width', widthHeader)
        selectorHeader.css('min-width', widthHeader)
        selectorHeader.css('max-width', widthHeader)
      })
    },
    updateCurrentPage (val) {
      this.currentPage = val
      this.checkAll = false
      this.$emit('checkBoxAll', this.checkAll)
      this.pageData.length = 0
      this.countData = 0
    }
  },
  watch: {
    checkedItems: {
      handler () {
        this.checkAll = this.checkedItems.length > 0 && this.checkedItems.length === this.defaultData.length
        $('#amz-delete-checkbox-all').prop('checked', this.checkAll)
      },
      deep: true
    },
    maxRows () {
      this.checkAll = false
      this.$emit('checkBoxAll', this.checkAll)
      this.pageData.length = 0
      this.countData = 0
    }
  },
  updated () {
    // Debounce to avoid getBoundingClientRect running on every Vue update.
    clearTimeout(this._headerDebounceTimer)
    this._headerDebounceTimer = setTimeout(() => {
      this.resetHeaderTabAddByAmazon()
    }, 50)
  },
  mounted () {
    window.addEventListener('resize', this.resetHeaderTabAddByAmazon)
  },
  beforeDestroy () {
    // Clean up timer and resize listener to prevent memory leaks.
    clearTimeout(this._headerDebounceTimer)
    window.removeEventListener('resize', this.resetHeaderTabAddByAmazon)
  }
}
</script>
<style scoped>
.position-relative {
  position: relative;
}
.box-thead-add-by-amazon-sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 62px;
  z-index: 10;
  margin-bottom: -57px;
}
.table-wrapper-add-by-amazon-sticky {
  height: 57px;
  overflow: hidden;
}
.box-thead-add-by-amazon-sticky .box-empty {
  background-color: #f9f9f9;
  height: 50px;
}
.thead-not-visibility {
  visibility: hidden;
}
.tbody-not-visibility {
  visibility: hidden;
}
.common-table {
  font-size: 14px;
}
.common-table > tbody > tr:hover {
  background-color: unset;
}
.common-table > thead > tr > th {
  background-color: #deebf7;
  color: #595959;
}
.common-table > tbody > tr.child:hover {
  background-color: beige;
}
.common-table > tbody > tr.bg-product-stopped:hover {
  background-color: #d8d8d8;
}
.common-table > tbody > tr.bg-danger:hover {
  background-color: #f2dede;
}
.common-table th {
  font-weight: 800;
}
.common-table .child {
  background-color: beige;
  cursor: pointer;
}
.common-table tr.child tr.child td:nth-child(2)
,tr.child td:nth-child(4),tr.child td:nth-child(5),tr.child td:nth-child(6),tr.child td:nth-child(7) {
  border-left-color: beige;
}
tr.child td:nth-child(4) {
  border-right-color: beige;
}
.common-table tr td {
  vertical-align: top;
  padding-top: 15px;
}
.common-table tr:not(.child, .not-child) td:first-child {
  background-color: beige;
}
.common-table tr.not-child td:nth-child(3){
  text-align: left !important;
}
.common-table tr:not(.child, .not-child) td:nth-child(3) {
  text-align: left !important;
}
.common-table .product-name {
  min-width: 450px;
  text-align: left;
}
.common-table .head-offer-price {
  text-align: right;
}
.common-table .head-number-of-stock {
  text-align: left;
}
.common-table /deep/ .box-label-number-of-stock {
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin: auto -8px;
  min-width: 440px;
}
.common-table /deep/ .box-label-number-of-stock .explan-icon {
  font-size: 25px;
  cursor: pointer;
}
.common-table .column-number-of-stock .yamato-shipping {
  align-items: start;
}
.common-table .column-number-of-stock .line-seperate {
  margin: 10px -8px;
  border-color: #ddd;
}
.common-table .table-alert span {
  width: 185px;
}
.table-wrapper-sticky {
  overflow: hidden;
}
.thead-not-visibility {
  visibility: hidden;
}
.tbody-not-visibility {
  visibility: hidden;
}
.box-thead-sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 62px;
  z-index: 99;
  margin-bottom: -57px;
}
.box-thead-sticky .box-action-all {
  height: 50px;
  background-color: #f9f9f9;
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding-bottom: 5px;
}
.box-thead-sticky .box-action-all .btn-warning {
  margin-right: 0;
  padding: 5px 30px;
  border-radius: 5px;
}
.grouped-table-header {
  text-align: left;
}
@media (max-width: 1600px) {
  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
   }
  .common-table .product-name {
    min-width: 450px !important;
  }
}
@media (max-width: 768px) {
  .box-thead-sticky {
    top: 42px;
  }
  .box-thead-sticky  .box-action-all .btn-warning {
    padding: 3px 15px;
  }
}
@media (max-width: 768px) {
  .box-thead-add-by-amazon-sticky {
    top: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AddByAmazonTable.vue